import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { fetchNews, deleteNews } from 'actions/News'
import NewsView from 'components/pages/news'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchNews: bindActionCreators(fetchNews, dispatch),
  deleteNews: bindActionCreators(deleteNews, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isLoading', 'setIsLoading', false),
  withState('stateSearch', 'setStateSearch', {}),
  withState('data', 'setData', {}),
  withHandlers({
    getList: props => async (params) => {
      const { setData, setIsLoading } = props
      setIsLoading(true)
      try {
        const res = await props.fetchNews(params)
        setData({
          list: res.data,
          meta: res.meta,
        })
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
  }),
  withHandlers({
    handleDelete: props => async (id) => {
      const { setIsLoading, getList } = props
      setIsLoading(true)

      try {
        const res = await props.deleteNews(id)
        message.success(res)
        getList(`?limit=100`)
        setIsLoading(false)
      } catch (err) {
        setIsLoading(false)
      }
    },
    handleChangePage: props => (val) => {
      const { getList } = props
      getList(`?page=${val}`)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfigs({
        titlePage: 'Info & Berita',
        activePage: 'news',
        activeSubPage: 'news',
      })

      this.props.getList(`?limit=100`)
    },
  }),
)(NewsView)
